// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.growth.listing.RentalManagerGrowthGetCompStatsForListingWebApiHandler

import type { QueryOptions, UseQueryOptions } from '@zg-rentals/react-query5';
import { useQuery } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  RentalManagerGrowthGetCompStatsForListingWebApiHandler_getCompStats,
  RentalManagerGrowthGetCompStatsForListingWebApiHandler_getCompStats_Path,
} from '@zg-rentals/ts-rental-manager-api-client';

import type { GetCompStatsForListingResponseWebDto, ListingAlias } from '@zg-rentals/ts-rental-manager-api-client';

interface GetCompStatsParams {
  listingAlias: ListingAlias;
}

export type RentalManagerGrowthGetCompStatsForListingWebApiHandler_getCompStats_Options = UseQueryOptions<
  GetCompStatsForListingResponseWebDto,
  unknown,
  GetCompStatsForListingResponseWebDto,
  readonly [string, GetCompStatsParams]
>;

const RentalManagerGrowthGetCompStatsForListingWebApiHandler_getCompStats_GetKey = (getParams: GetCompStatsParams) =>
  [RentalManagerGrowthGetCompStatsForListingWebApiHandler_getCompStats_Path, getParams] as const;

export const RentalManagerGrowthGetCompStatsForListingWebApiHandler_getCompStats_queryOptions = (
  getParams: GetCompStatsParams,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerGrowthGetCompStatsForListingWebApiHandler_getCompStats_GetKey(getParams),
    queryFn: () => RentalManagerGrowthGetCompStatsForListingWebApiHandler_getCompStats(getParams, httpClient),
  }) as const satisfies QueryOptions;

/**
 * Get comp stats (views/inquiries) for a listing and its similar floorplans
 */
export const useRentalManagerGrowthGetCompStatsForListingWebApiHandler_getCompStats = (
  getParams: GetCompStatsParams,
  {
    httpClient,
    ...options
  }: Omit<RentalManagerGrowthGetCompStatsForListingWebApiHandler_getCompStats_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...RentalManagerGrowthGetCompStatsForListingWebApiHandler_getCompStats_queryOptions(getParams, { httpClient }),
    ...options,
  });
};
useRentalManagerGrowthGetCompStatsForListingWebApiHandler_getCompStats.getKey =
  RentalManagerGrowthGetCompStatsForListingWebApiHandler_getCompStats_GetKey;
